import { LinearProgress } from '@material-ui/core';

import { PageLayout } from '@spotify/confidence-core-react';

import { PageBreadcrumbs } from '../../../../PageBreadcrumbs';
import { useOptionalPageBridgeProps } from '../../../../utils';

// eslint-disable-next-line @spotify-confidence/page-requires-tracking -- rendered inside already-tracked pages via ResourceGuard; tracking happens at the parent
export const ResourceLoadingPage = () => {
  const bridgeProps = useOptionalPageBridgeProps();

  return (
    <PageLayout
      headerBreadcrumbs={<PageBreadcrumbs />}
      narrow={bridgeProps?.narrow}
    >
      <LinearProgress />
    </PageLayout>
  );
};
